import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useLoadingStore = defineStore('loading', () => {
  const isLoading = ref(false);
  const loadingText = ref('Cargando...');

  function setLoading(value, text = 'Cargando...') {
    isLoading.value = value;
    loadingText.value = text;
  }

  function closeLoading() {
    isLoading.value = false;
    loadingText.value = 'Cargando...';
  }

  return { isLoading, loadingText, closeLoading, setLoading };
});
